import { render, staticRenderFns } from "./Screenshot.vue?vue&type=template&id=35ec8480&scoped=true&"
import script from "./Screenshot.vue?vue&type=script&lang=js&"
export * from "./Screenshot.vue?vue&type=script&lang=js&"
import style0 from "./Screenshot.vue?vue&type=style&index=0&id=35ec8480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ec8480",
  null
  
)

export default component.exports